import React, {Component, Fragment} from 'react';
import PropTypes from 'prop-types';
import PagingButtons from './PagingButtons';

class TablePager extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activePage: 1,
      maxPageItems: {value: 5, label: '5'},
    };
  }

  handleMaxItemsChange = maxPageItems => {
    this.setState({maxPageItems});
    const maxPage = Math.ceil(this.props.data.length / maxPageItems.value);
    if(this.state.activePage > maxPage){
      this.setState({activePage: maxPage});
    }
  };

  changePage = (pageNum) => {
    this.setState({activePage: pageNum});
  };

  render() {

    const start = (this.state.activePage-1)*this.state.maxPageItems.value;
    const end = this.state.activePage * this.state.maxPageItems.value;
    let items = this.props.data.slice(start, end);

    return (
      <Fragment>
        {this.props.dataTable(items, start)}
        <PagingButtons
          activePage={this.state.activePage}
          maxPageItems={this.state.maxPageItems}
          handleMaxItemsChange={this.handleMaxItemsChange}
          numberOfItems={this.props.data.length}
          changePage={this.changePage}
        />
      </Fragment>
    );
  }
}

TablePager.propTypes = {
  data: PropTypes.array.isRequired,
  dataTable: PropTypes.func.isRequired,
};

export default TablePager;


// WEBPACK FOOTER //
// ./src/components/TablePager.js